import { Nullable } from '../types/Typescript-utils';
import { TintError } from '../utils/tint-error';
import { ImageClientService } from './image-client.service';
import sdkConfig from '../config/config-sdk';

const ImageEffects = {
  GRAYSCALE: 'grayscale',
  NEGATE: 'negate',
  SEPIA: 'sepia',
  OIL_PAINT: 'oil_paint',
  BLUR: 'blur',
  NONE: 'none',
};

export default class FileLinkClientService {
  private readonly client: ImageClientService;
  private readonly effect?: Nullable<string>;
  private readonly noImagesScaling?: boolean;

  constructor({
    url,
    imageEffect,
    noImagesScaling,
  }: {
    url: string;
    imageEffect?: Nullable<string>;
    noImagesScaling?: boolean;
  }) {
    if (!url) {
      throw new TintError({
        message: 'Url can not be null or empty string',
      });
    }

    this.client = new ImageClientService(url, sdkConfig.REACT_APP_FILESTACK_API_KEY);
    // this.client.setUseValidator(false);
    this.effect = imageEffect;
    this.noImagesScaling = noImagesScaling !== undefined ? noImagesScaling : false;
  }

  public autoImage = () => {
    this.client.autoImage();
    return this;
  };

  public noMetadata = () => {
    this.client.noMetadata();
    return this;
  };

  public compress = () => {
    this.client.compress();
    return this;
  };

  public rotate = () => {
    this.client.rotate();
    return this;
  };

  public resize = (params: { width?: number; height?: number }) => {
    if (this.noImagesScaling === false) {
      this.client.resize(params);
    }
    return this;
  };

  public reset = () => {
    this.client.reset();
    return this;
  };

  public toString = () => {
    return this.client.toString();
  };

  public applyEffect = () => {
    if (!this.effect) {
      return this;
    }
    switch (this.effect) {
      case ImageEffects.GRAYSCALE:
        this.client.monochrome();
        return this;

      case ImageEffects.SEPIA:
        this.client.sepia();
        return this;

      case ImageEffects.NEGATE:
        this.client.negative();
        return this;

      case ImageEffects.OIL_PAINT:
        this.client.oilPaint();
        return this;
      case ImageEffects.BLUR:
        this.client.blur();
        return this;
      case ImageEffects.NONE:
        return this;

      default:
        return this;
    }
  };

  public getClient = (): ImageClientService => this.client;
}
